import React from 'react';
import { ShieldCheck, Lock, Users, Mail, Phone, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';

const services = [
  { name: 'Medical Billing & Coding', to: '/services' },
  { name: 'Revenue Cycle Management', to: '/services' },
  { name: 'Insurance Eligibility Verification', to: '/services' },
  { name: 'Denial Management', to: '/services' },
  { name: 'Accounts Receivable Follow-up', to: '/services' },
  { name: 'Reporting & Analytics', to: '/services' },
];

const quickLinks = [
  { name: 'Home', to: '/' },
  { name: 'About Us', to: '/about' },
  { name: 'Services', to: '/services' },
  { name: 'Analytics & Reporting', to: '/analytics' },
  { name: 'FAQ', to: '/faq' },
  { name: 'Contact Us', to: '/contact' },
  { name: 'Privacy Policy', to: '/privacy' },
  { name: 'Terms of Service', to: '/terms' },
  { name: 'HIPAA Compliance', to: '/hipaa' },
];

function Footer() {
  return (
    <footer style={{ background: '#2B4278', color: '#fff', padding: '3.5rem 0 0 0', marginTop: '3rem', fontSize: '0.98rem' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 1.5rem' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '2.5rem', borderBottom: '1.5px solid #2EB8A8', paddingBottom: '2.5rem' }}>
          {/* Column 1: Logo + About */}
          <div>
            <div style={{ marginBottom: '1.1rem' }}>
              <img src={process.env.PUBLIC_URL + '/logo_2.jpeg'} alt="OptiBill Analytics Logo" style={{ height: 48, marginBottom: 10 }} />
            </div>
            <div style={{ fontWeight: 600, fontSize: '1.08rem', marginBottom: '0.7rem', lineHeight: 1.5 }}>
              OptiBill Analytics is a trusted medical billing and revenue cycle management partner, helping healthcare providers to maximize revenue, reduce denials, and stay compliant.
            </div>
            <div style={{ display: 'flex', gap: 12, marginTop: 18 }}>
              <span title="HIPAA Compliant"><ShieldCheck size={20} color="#2EB8A8" /></span>
              <span title="Secure Workflows"><Lock size={20} color="#2EB8A8" /></span>
              <span title="Experienced RCM Team"><Users size={20} color="#2EB8A8" /></span>
            </div>
          </div>
          {/* Column 2: Services */}
          <div>
            <div style={{ fontWeight: 700, fontSize: '1.08rem', marginBottom: 18, color: '#fff', letterSpacing: '0.01em' }}>Services</div>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {services.map((item, idx) => (
                <li key={idx} style={{ marginBottom: 10 }}>
                  <Link to={item.to} style={{ color: '#b3c0dd', textDecoration: 'none', fontSize: '0.97rem', transition: 'color 0.18s' }}
                    onMouseOver={e => e.target.style.color = '#2EB8A8'}
                    onMouseOut={e => e.target.style.color = '#b3c0dd'}>{item.name}</Link>
                </li>
              ))}
            </ul>
          </div>
          {/* Column 3: Quick Links */}
          <div>
            <div style={{ fontWeight: 700, fontSize: '1.08rem', marginBottom: 18, color: '#fff', letterSpacing: '0.01em' }}>Quick Links</div>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {quickLinks.map((item, idx) => (
                <li key={idx} style={{ marginBottom: 8 }}>
                  <Link to={item.to} style={{ color: '#b3c0dd', textDecoration: 'none', fontSize: '0.97rem', transition: 'color 0.18s' }}
                    onMouseOver={e => e.target.style.color = '#2EB8A8'}
                    onMouseOut={e => e.target.style.color = '#b3c0dd'}>{item.name}</Link>
                </li>
              ))}
            </ul>
          </div>
          {/* Column 4: Contact */}
          <div>
            <div style={{ fontWeight: 700, fontSize: '1.08rem', marginBottom: 18, color: '#fff', letterSpacing: '0.01em' }}>Contact</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}><Mail size={18} color="#2EB8A8" /><span>info@optibillanalytics.com</span></div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}><Phone size={18} color="#2EB8A8" /><span>+91 7990694893</span></div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}><Clock size={18} color="#2EB8A8" /><span>24×7 Support Available</span></div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 18 }}><span role="img" aria-label="location">📍</span><span>Global Delivery | India</span></div>
            <button style={{ background: '#2EB8A8', color: '#fff', fontWeight: 600, border: 'none', borderRadius: 22, padding: '0.7rem 1.5rem', marginTop: 8, fontSize: '0.98rem', display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', transition: 'background 0.18s' }}
              onMouseOver={e => e.target.style.background = '#27a395'}
              onMouseOut={e => e.target.style.background = '#2EB8A8'}
              onClick={() => window.openContactPopup && window.openContactPopup()}>
              Request Free Consultation
            </button>
          </div>
        </div>
        {/* Bottom Bar */}
        <div style={{ textAlign: 'center', color: '#b3c0dd', fontSize: '0.97rem', padding: '1.2rem 0 0.7rem 0', display: 'flex', flexDirection: 'column', gap: 6 }}>
          <div style={{ marginBottom: 4 }}>
            <span style={{ color: '#2EB8A8', fontWeight: 600 }}>HIPAA-Compliant</span> | Secure & Confidential Billing Services
          </div>
          <div>
            &copy; {new Date().getFullYear()} OptiBill Analytics. All Rights Reserved. &nbsp;
            <Link to="/privacy" style={{ color: '#b3c0dd', textDecoration: 'underline', marginRight: 10 }}>Privacy Policy</Link>
            <Link to="/terms" style={{ color: '#b3c0dd', textDecoration: 'underline' }}>Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
